<template>
    <div class="profile-menu-mobile">
        <el-row type="flex" justify="left" class="hidden-md-and-up">

            <el-col :xs="{span: 24}" :sm="{span: 24}">

                <el-divider>{{user.username || 'Anonymous'}}</el-divider>

                <el-row type="flex" justify="center">
                    <el-image :src="userAvatar" @click="changeMode('profile')" class="clickable"></el-image>
                    <el-image :src="user.currentStatus === 'online' ? onlineIcon : offlineIcon" class="user-profile-status"></el-image>

                    <div v-if="layout === 'peaking'" class="peaking-tag">Peaking</div>
                </el-row>

                <el-row type="flex" justify="center" class="profile-menu">
                    <el-col :xs="{span: 5}" :sm="{span: 5}">
                        <div @click="changeMode('profile')" :class="`clickable ${mode === 'profile' ? 'active' : ''}`">
                            Profile
                        </div>
                    </el-col>

                    <el-col :xs="{span: 7}" :sm="{span: 7}" v-if="layout === 'peaking'">
                        <!---------------------------->
                        <!-- Show declined if declined -->
                        <!---------------------------->
                        <div class="declined small-icon" v-if="user.status === 'decline'">
                            <i class="el-icon-remove"></i>Friend
                        </div>

                        <!---------------------------->
                        <!-- Send friendship -->
                        <!---------------------------->
                        <div  @click="sendFriendRequest" :class="`clickable small-icon`"  v-if="user.status === 'none'">
                            <i class="el-icon-circle-plus"></i>Friend
                        </div>

                        <!---------------------------->
                        <!-- End friendship or Show cancel button if waiting for response -->
                        <!---------------------------->
                        <el-dropdown trigger="click" @command="submitFriendRequest" v-if="['accepted', 'waiting'].includes(user.status)">
                            <span class="clickable small-icon" >
                                <i class="el-icon-loading" v-if="user.status === 'waiting'"></i>Friend
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <!-- End friendship -->
                                <el-dropdown-item command="decline" v-if="user.status === 'accepted'">remove friend</el-dropdown-item>
                                <!-- Show cancel button if waiting for response -->
                                <el-dropdown-item command="decline" v-if="user.status === 'waiting'">Cancel request</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>

                        <!---------------------------->
                        <!-- Show accept or decline buttons if receiving request -->
                        <!---------------------------->
                        <el-dropdown trigger="click" @command="submitFriendRequest" v-if="user.status === 'pending'">
                            <span class="clickable small-icon">
                                <i class="el-icon-loading"></i>Friend
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="accept">Accept request</el-dropdown-item>
                                <el-dropdown-item command="decline">Decline request</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-col>

                    <el-col :xs="{span: 5}" :sm="{span: 5}" v-if="layout === 'default'">
                        <el-dropdown trigger="click" @command="changeMode">
                            <span :class="`el-dropdown-link clickable ${['friends', 'addFriend'].includes(mode) ? 'active' : ''}`">
                                Friends
                            </span>

                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="friends">All friends {{user.counts.friends ? ` (${user.counts.friends})`: ''}}</el-dropdown-item>
                                <el-dropdown-item command="addFriend">Add friend</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-col>

                    <el-col :xs="{span: 5}" :sm="{span: 5}" v-if="user.counts">
                        <el-dropdown trigger="click" @command="changeMode">
                            <span :class="`el-dropdown-link clickable ${['myGames', 'going2play', 'playing', 'finished', 'played'].includes(mode) ? 'active' : ''}`">
                                Games
                            </span>

                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="myGames">All Games{{user.counts.myGames ? ` (${user.counts.myGames})`: ''}}</el-dropdown-item>
                                <el-dropdown-item command="going2play">Going to play {{user.counts.going2playGames ? ` (${user.counts.going2playGames})`: ''}}</el-dropdown-item>
                                <el-dropdown-item command="playing">Playing {{user.counts.playingGames ? ` (${user.counts.playingGames})`: ''}}</el-dropdown-item>
                                <el-dropdown-item command="finished">Finished {{user.counts.finishedGames ? ` (${user.counts.finishedGames})`: ''}}</el-dropdown-item>
                                <el-dropdown-item command="played">Played {{user.counts.playedGames ? ` (${user.counts.playedGames})`: ''}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-col>

                    <el-col :xs="{span: 5}" :sm="{span: 5}" v-if="layout === 'default'">
                        <div @click="changeMode('settings')" :class="`clickable ${mode === 'settings' ? 'active' : ''}`">
                            Settings
                        </div>
                    </el-col>
                </el-row>

            </el-col>

        </el-row>
    </div>
</template>

<script>
import Background from '@/components/background.vue'

export default {
  name: 'ProfileMenuMobile',
  components: { Background },
  props: {
    changeMode: {
      default: () => {}
    },
    sendFriendRequest: {
      default: () => {}
    },
    submitFriendRequest: {
      default: () => {}
    },
    user: {
      default: {}
    },
    mode: {
      default: 'profile'
    },
    layout: {
      default: 'default'
    }
  },
  mounted () {},
  data () {
    return {
      userAvatar: require(`@/assets/${this.user.avatar || 'avatar1'}.png`),
      onlineIcon: require(`@/assets/icon-onn.png`),
      offlineIcon: require(`@/assets/icon-off.png`),
      awayIcon: require(`@/assets/icon-away.png`)
    }
  },

  methods: {}
}
</script>

<style lang="scss">
@import '../styles/variables.scss';

.profile-menu-mobile {
    .small-icon {
        i {
            font-size: $font-size-small;
        }
    }

    .declined {
        text-shadow: #ff0000 1px 0 10px;
    }

    .user-profile-status {
        position: absolute;
        margin-left: 87px;
        margin-top: 262px;
    }

    .peaking-tag {
        font-size: 18px;
        color: #4e5953;
        position: absolute;
        background-color:$main-color-2;
        bottom: 0px;
        padding-right: 5px;
        padding-left: 5px;
        padding-top: 5px;
        padding-bottom: 5px;
        border-width: 4px;
        border-style: solid;
        border-color: #4e5953;
    }

    .el-dropdown {
        color: $main-color-2;
        font-size: $font-size-regular;
    }

    @media screen and (max-width: 62em) {
        .profile-menu {
            margin:5px;

            .active {
                color: $a-ref-color;
            }
        }
    }
}
</style>
